/*@flow */

import React from 'react';
import { withTranslation } from 'react-i18next';

import { toast } from 'react-toastify';

import './ycContactUs.scss';
import { httpService } from '../../services/Http';

export const YcContactUs = withTranslation()(
  class YcContactUsClass extends React.PureComponent {
    state = {
      form: {
        name: '',
        email: '',
        phone: '',
        content: '',
        society: '',
        subject: 'Demande de devis',
      },
      error: '',
    };

    subjects = ['devis', 'partnership', 'informations', 'other']

    handleChange = ({ target: { name, value } }) => {
      this.setState({
        form: {
          ...this.state.form,
          [name]: value,
        },
      });
    };

    onSendMessage = e => {
      e.preventDefault();
      const { name, email, phone, content, society, subject } = this.state.form;
      if (name.length > 0 && email.length > 0 && content.length > 0) {
        httpService
          .postToAPI('/contacts/send-mail', {
            name,
            emailContact: email,
            phone,
            content,
            society,
            subject,
          })
          .then(e => {
            toast.success(e.data);
            this.setState({
              form: {
                name: '',
                email: '',
                phone: '',
                content: '',
                society: '',
                subject: 'Demande de devis',
              },
            });
          })
          .catch(e => console.log(e));
      } else {
        const error = 'Merci de remplir tous les champs obligatoires (*)';
        this.setState({ error });
        setTimeout(() => {
          const error = '';
          this.setState({ error });
        }, 3000);
      }
    };

    renderForm() {
      const { t } = this.props;
      const { name, email, phone, content, society, subject } = this.state.form;
      const error = this.state.error;

      return (
        <form onSubmit={this.onSendMessage}>
          <div className="container">
            {error ? (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            ) : (
              ''
            )}
            <div className="row">
              <div className="col-md-5">
                <input placeholder={t('contact.form.name') + ' *'} name="name" onChange={this.handleChange} value={name} />
                <input placeholder={t('contact.form.email') + ' *'} name="email" onChange={this.handleChange} value={email} />
                <input placeholder={t('contact.form.phone')} name="phone" onChange={this.handleChange} value={phone} />
                <input placeholder={t('contact.form.society')} name="society" onChange={this.handleChange} value={society} />
              </div>
              <div className="col-md-7 text-left">
                <select value={subject} name="subject" onChange={this.handleChange}>
                  {this.subjects.map((e, i) => (
                    <option value={t(`contact.form.subject.${e}`)} key={i}>
                      {t(`contact.form.subject.${e}`)}
                    </option>
                  ))}
                </select>
                <textarea
                  placeholder={t('contact.form.content') + ' *'}
                  name="content"
                  onChange={this.handleChange}
                  value={content}
                  rows={4}
                />
                <button onClick={this.onSendMessage} className="btn btn-primary btn-lg">
                  {/* <NearMe /> */}
                  <span className="ml-2">{t('contact.form.send')}</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      );
    }

    render() {
      const { t } = this.props;

      return (
        <div className="yc-contact-us" id="contact-us">
          <h2 dangerouslySetInnerHTML={{ __html: t('contact.title') }} />
          {/* {this.renderYsoCorp()} */}
          <div className="content">{this.renderForm()}</div>
        </div>
      );
    }
  },
);
